import { Component, OnDestroy, OnInit } from '@angular/core';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import { Router } from '@angular/router';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { SubSink } from 'subsink';

import { User } from '@app/api/marketplace/models';
import {
  AuthenticationActions,
  AuthenticationSelectors,
} from '@authentication/store/authentication.slice';
import { DialogComponent } from '@shared/components/dialog/dialog.component';
import { ApiErrorResponse } from '@shared/interfaces/api-error-response';

@Component({
  selector: 'app-merchant-user-registration',
  templateUrl: './merchant-user-registration.component.html',
  styleUrls: ['./merchant-user-registration.component.scss'],
})
export class MerchantUserRegistrationComponent implements OnInit, OnDestroy {
  merchantId?: string;

  merchantId$: Observable<string> = this.store.select(
    AuthenticationSelectors.selectMerchantId
  );
  isLoading$: Observable<boolean> = this.store.select(
    AuthenticationSelectors.selectIsLoading
  );
  response$: Observable<User> = this.store.select(
    AuthenticationSelectors.selectMerchantUserRegistrationResponse
  );
  errorResponse$: Observable<ApiErrorResponse | undefined> = this.store.select(
    AuthenticationSelectors.selectMerchantUserRegistrationErrorResponse
  );

  private subs = new SubSink();

  constructor(
    private store: Store,
    private matDialog: MatDialog,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.subs.sink = this.merchantId$.subscribe((merchantId) => {
      if (!merchantId) {
        this.router.navigate(['/auth/merchant-registration'], {
          replaceUrl: true,
        });
      } else {
        this.merchantId = merchantId;
      }
    });
    this.subs.sink = this.response$.subscribe((response) => {
      if (response && response.firstName !== '') {
        this.openSuccessDialog();
      }
    });
  }

  onContinue(formValue: any): void {
    this.store.dispatch(
      AuthenticationActions.registerMerchantUser.trigger({ user: formValue })
    );
  }

  openSuccessDialog(): void {
    const dialogRef: MatDialogRef<DialogComponent> = this.matDialog.open(
      DialogComponent,
      {
        data: {
          type: 'NOTICE',
          title: 'REGISTRATION.DIALOG.TITLE',
          content: 'REGISTRATION.DIALOG.MSG',
        },
      }
    );

    dialogRef
      .afterClosed()
      .subscribe((notificationDialogResult: boolean | undefined): void => {
        if (notificationDialogResult) {
          this.store.dispatch(AuthenticationActions.resetState());
          this.router.navigate(['']);
        }
      });
  }

  ngOnDestroy(): void {
    this.subs.unsubscribe();
  }
}
